import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
//按需引入组件
import './utils/element.js'
import Pagination from "@/components/Pagination";
// import 'v-treeview/dist/v-treeview.css'
import VueI18n from 'vue-i18n';
import cookie from 'js-cookie';
import {imgUrlPrefix} from './utils/setupConfig';
Vue.use(VueI18n);
Vue.prototype.cookie = cookie;


// 设置 cookie 工具函数
Vue.prototype.set_cookie = (name, data, expires) => {
  cookie.set(name, data, {
    expires: expires
  })
}

const i18n = {
  locale: cookie.get('lang') || 'zh', // 语言标识,第一次登录默认是中文
  messages: {
    zh: require('@/assets/language/local_zh'), // 汉语
    en: require('@/assets/language/local_en'), // 英语
  }
}

Vue.component('Pagination', Pagination);
// 接口使用的参数  1中文 2英文
Vue.prototype.apiLangType = cookie.get('lang')=='zh'?1:cookie.get('lang')=='en'?2:1;
// Vue.prototype.apiLangType = cookie.get('lang')==''||cookie.get('lang')==undefined||cookie.get('lang')=='zh'?1:2;

Vue.config.productionTip = false
Vue.prototype.isMobile = () =>{
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}
Vue.prototype.imgUrlPrefix=imgUrlPrefix

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')



